import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from "react-router-dom";
import { CustomLayout } from '../components';
import { HeaderAdmin, MenuAdmin } from '../pages/AdminInmersys';

export const LayoutAdminInmersys = () => {
    const { typeAdmin } = useSelector((state) => state.auth);
    console.log("uset type:", typeAdmin)
    return typeAdmin === 'INMERSYS' ? <CustomLayout>
        <HeaderAdmin />
        <MenuAdmin />
        <div className='pt-16 pl-[208px] w-full h-full'>
            <Outlet></Outlet>
        </div>
    </CustomLayout> : <Navigate to={"/auth/"}> </Navigate>

}

export default LayoutAdminInmersys
